import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  AppFeatureService,
  AppService,
  AppSubscriptionState,
  AppSubscriptionStateDetails,
  SystemEnvBannerComponent,
} from '@nk/access-block';
import { SystemEnvEntity } from '@nk/data-entities-lib';
import { APP_ENV_CONFIG_TOKEN, AppEnvConfig, EnvironmentKey } from '@nk/utils-lib';
import { Observable } from 'rxjs';

@Component({
  selector: 'nk-site-warning-top-banner',
  standalone: true,
  imports: [AsyncPipe, DatePipe, RouterModule, TranslateModule, SystemEnvBannerComponent],
  templateUrl: './site-warning-top-banner.component.html',
})
export class SiteWarningTopBannerComponent implements OnInit {
  public environmentKey: EnvironmentKey;
  public envColors: Record<EnvironmentKey, string> = {
    local: 'danger',
    test: 'warning',
    beta: 'success',
    dev: 'success',
    pre: 'success',
    prod: '',
  };
  public subscriptionData$: Observable<AppSubscriptionStateDetails>;
  public systemEnv$: Observable<SystemEnvEntity>;
  public appSubscriptionState = AppSubscriptionState;

  constructor(
    private _appFeatureService: AppFeatureService,
    private _appService: AppService,
    @Inject(APP_ENV_CONFIG_TOKEN) private _appEnvConfig: AppEnvConfig,
  ) {
    if (this._appEnvConfig?.environmentKey !== 'prod') {
      this.environmentKey = this._appEnvConfig.environmentKey;
    }
  }

  public ngOnInit(): void {
    this.systemEnv$ = this._appService.systemEnvCache.get();
    this.subscriptionData$ = this._appFeatureService.appSubscriptionState();
  }
}
